import React, { forwardRef, useContext, useRef } from 'react';
import Modal from '../../../../../core/components/Modal';
import BaseForm from '../../../../../core/page/components/baseForm/BaseForm';
import InputField from '../../../../../components/inputField/InputField';
import { InputText } from 'primereact/inputtext';
import InputDropDown from '../../../../../core/components/inputs/inputDropDown/InputDropDown';
import styles from './ModalPesquisar.module.scss';
import { FilterInputs } from '../../../../../core/page/components/baseFilter/BaseFilter';
import TablePesquisar from './TablePesquisar';
import { Button } from 'primereact/button';
import { assignRefs } from '../../../../../core/utils/Global';
import { isEmpty } from '../../../../../core/utils/ValidForm';
import { MultipageContext } from '../../../../../core/components/Multipage';
import PageMessages from '../../../../../config/translations/PageMessages';
import ExercicioIntegracaoService from '../../../../../service/integracao/ExercicioIntegracaoService';

const listaInputs = [
    { name: 'instrumento', label: 'Instrumento', form: { use: true } },
    {
        name: 'exercicio',
        label: 'Exercício',
        form: { use: true, validate: { required: true } },
        filter: { nameUse: 'exercicio.ano' },
    },
    {
        name: 'exercicioView',
        label: 'Exercício',
        table: { use: true },
    },
    {
        name: 'codigo',
        label: 'Código',
        form: { use: true },
        table: { use: true },
        filter: { nameUse: 'codigoEixo' },
    },
    {
        name: 'nome',
        label: 'Nome',
        form: { use: true },
        table: { use: true },
        filter: { nameUse: 'nomeEixo' },
    },
];

function ModalPesquisar(props, ref) {
    const tableRef = useRef(null);
    const formRef = useRef(null);
    const modalRef = useRef(null);
    const { confirmOkRef } = useContext(MultipageContext);

    const Inputs = ({ formik, formController }) => (
        <form
            ref={formRef}
            onSubmit={formik.handleSubmit}
            className={`p-col-12 p-grid p-fluid ${styles.form}`}
        >
            <InputField formController={formController} formik={formik} id="exercicio" cols="12 3">
                <InputDropDown
                    formik={formik}
                    valueIsCompleteObject
                    optionValue="idenExercicio"
                    optionLabel="ano"
                    filter
                    callbackSetList={ExercicioIntegracaoService.list.bind(
                        ExercicioIntegracaoService
                    )}
                />
            </InputField>
            <InputField formController={formController} formik={formik} id="codigo" cols="12 2">
                <InputText value={formik.values.codigo} onChange={formik.handleChange} />
            </InputField>
            <InputField formController={formController} formik={formik} id="nome" cols="12 4">
                <InputText value={formik.values.nome} onChange={formik.handleChange} />
            </InputField>
            <FilterInputs
                initialValues={formController.initialValues}
                formik={formik}
                formRef={formRef}
                onClick={() => formController.addCountClick()}
            />
        </form>
    );
    const ModalBody = ({ modalData }) => (
        <>
            <BaseForm
                showToast={false}
                redirectOnSave={false}
                buscarOnLoad={false}
                onSubmit={async ({ registro }) => tableRef.current?.onFiltro(registro)}
                initialValues={listaInputs.filter((input) => input?.form?.use ?? false)}
                prepareInitialValues={(data) => ({ ...data, instrumento: modalData.instrumento })}
            >
                <Inputs />
            </BaseForm>
            <TablePesquisar
                instrumento={modalData.instrumento}
                ref={tableRef}
                listaInputs={listaInputs}
            />
            <div className="buttonsRight">
                <Button
                    label="Voltar"
                    className="p-button-secondary"
                    type="button"
                    icon="pi pi-arrow-left"
                    onClick={() => modalRef.current?.hide()}
                />
                <Button
                    label="Confirmar"
                    className="p-button-info"
                    type="button"
                    icon="pi pi-check-square"
                    onClick={() => {
                        if (!isEmpty(tableRef.current?.selected)) {
                            modalRef.current?.hide({
                                ...tableRef.current?.selected,
                                instrumento: modalData.instrumento,
                            });
                        } else {
                            confirmOkRef.current?.show(
                                PageMessages.sei.propostaIndicador.findModalRequiredInputs
                            );
                        }
                    }}
                />
            </div>
        </>
    );
    return (
        <Modal
            header={
                <>
                    <i className={`pi pi-search-plus ${styles.iconHeader}`} />
                    Pesquisar e Selecionar Vínculo
                </>
            }
            style={{ width: '90vw' }}
            widthOnMobile={700}
            onMobile={(styles) => ({ ...styles, maxWidth: '100vw', height: '100%' })}
            ref={assignRefs(ref, modalRef)}
            {...props}
        >
            <ModalBody />
        </Modal>
    );
}

export default forwardRef(ModalPesquisar);
